import WeaColorPicker from "../../wea-color-picker/index";
import constant from "../constant";
const { normalColors } = constant;

export default class ColorPanel extends React.Component {
  static defaultProps = {
    prefixCls: "wea-signature",
    normalColors
  };
  constructor(props) {
    super(props);
    this.state = {
      color: props.defaultColor || props.color || "#000" // 默认笔触颜色
    };
  }
  componentDidMount() {
    const { color } = this.props;
    if (color) this.setState({ color });
  }
  compomentWillReceiveProps(nextProps) {
    const { color } = nextProps;
    const { color: _color } = this.props;
    if (color && color !== _color) {
      this.setState({ color });
    }
  }
  onChangeColor = value => {
    this.setState({ color: value });
    const { onChangeColor } = this.props;
    if (typeof onChangeColor === "function") onChangeColor(value);
  };
  getNormalColors = (datas, isSecondLine) => {
    const { prefixCls } = this.props;
    return datas.map(v => (
      <span
        className={`${prefixCls}-tools-normalColors-single${
          isSecondLine ? "-two" : ""
        }`}
        style={{ background: v }}
        onClick={() => this.onChangeColor(v)}
      />
    ));
  };
  render() {
    const { prefixCls, devType, normalColors } = this.props;
    const { color } = this.state;
    const col = normalColors ? Math.ceil(normalColors.length / 2) : 10;
    return (
      <div
        className={`wea-f12 ${devType === "em" &&
          `${prefixCls}-tools-disabled`} ${prefixCls}-colorPanel`}
      >
        {devType !== "em" ? (
          <WeaColorPicker
            customized
            value={color}
            onChange={this.onChangeColor}
          >
            <div
              className={`${prefixCls}-tools-color`}
              style={{ background: color }}
            />
          </WeaColorPicker>
        ) : (
          <div className={`${prefixCls}-tools-color-disabled`} />
        )}
        <div className={`${prefixCls}-tools-normalColors`}>
          <div>{this.getNormalColors(normalColors.slice(0, col))}</div>
          <div>{this.getNormalColors(normalColors.slice(col), true)}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-signature/signature-tools/ColorPanel.js